import moment from 'moment-timezone';
import enums from 'goodeggs-purchase-orders-sdk/enums';
import * as sites from 'goodeggs-sites';

export default ngInject(function(
  $scope,
  $rootScope,
  $window,
  employeeRoles,
  $location,
  $state,
  foodhub,
  $stateParams,
  settings,
) {
  $scope.settings = settings;

  const outerAuth =
    __guard__(
      $rootScope.credentials != null ? $rootScope.credentials.google : undefined,
      (x) => x.employee,
    ) || {};
  $scope.linkToGithub = employeeRoles.can(outerAuth.roles != null ? outerAuth.roles : [], 'debug');

  $scope.foodhub = foodhub;
  $scope.foodhubSlug = $stateParams.foodhubSlug;
  $scope.currentDay = moment().format('YYYY-MM-DD');

  $scope.kaleUrl = sites.getUrl('kale', settings);

  // Copied from kale. Extract?
  $rootScope.updateStateClassArray = function() {
    $rootScope.stateClassArray = [];
    return (() => {
      const result = [];
      for (const component of Array.from($state.current.name.split('.'))) {
        let last = $rootScope.stateClassArray[$rootScope.stateClassArray.length - 1];
        last = last ? `${last}-` : '';
        result.push($rootScope.stateClassArray.push(`${last}${component}`));
      }
      return result;
    })();
  };

  $rootScope.updateStateClassArray();

  $rootScope.$on('$stateChangeSuccess', () => $rootScope.updateStateClassArray());

  $rootScope.logout = () =>
    // google auth is owned by kale.
    // need to clear kale session & all cross-domain token cookies.
    $window.location.replace(
      `${sites.getUrl('kale', settings)}/auth/logout?redirect=${encodeURIComponent(
        $location.absUrl(),
      )}`,
    );

  $rootScope.enums = enums;
});

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
